import {
  AfterViewInit,
  Component, ElementRef,
  EventEmitter,
  Input,
  OnInit, OnChanges, OnDestroy, SimpleChanges,
  Output, ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: "shoper-connect-otp-verification-code",
  templateUrl: "./otp-verification-code.component.html",
  styleUrls: ["./otp-verification-code.component.scss"],
  encapsulation: ViewEncapsulation.Emulated,
})
export class OtpVerificationCodeComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() phoneNumber: string;
  @Input() errorMessage = "";
  @Input() requestNumber = 0;
  @Input() loading = false;

  verificationGroup: UntypedFormGroup;
  @Output() submit = new EventEmitter<{ code: string }>();
  @Output() goBack = new EventEmitter();
  @Output() reSend = new EventEmitter();
  @ViewChild('input') input: ElementRef;

  tokenExtinct = false;
  private readonly codeLifetimeMs = 10 * 60 * 1000;
  private expirationTimer: ReturnType<typeof setTimeout>;



  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit() {
    this.verificationGroup = this.fb.group({
      code: ["", Validators.required],
    });
    this.codeControl.valueChanges.subscribe(value => {
      this.errorMessage = "";
    })
    this.startCodeTimer();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.requestNumber && this.verificationGroup) {
      this.verificationGroup.reset();
      this.startCodeTimer();
    }
  }

  ngOnDestroy(): void {
    clearTimeout(this.expirationTimer);
  }

  ngAfterViewInit(): void {
    this.input.nativeElement.focus();
  }

  get maskedPhoneNumber() {
    return "*** *** " + this.phoneNumber.slice(this.phoneNumber.length - 3);
  }

  get codeControl() {
    return this.verificationGroup.get('code');
  }

  onSubmit() {
    if (this.loading) return;
    this.errorMessage = "";
    const { code } = this.verificationGroup.getRawValue();
    this.codeControl.markAsDirty();
    this.submit.emit({ code });
  }

  sendSmsAgain() {
    if (this.loading) return;
    this.reSend.emit();
  }

  private startCodeTimer(): void {
    clearTimeout(this.expirationTimer);
    this.tokenExtinct = false;
    this.expirationTimer = setTimeout(() => {
      this.tokenExtinct = true;
    }, this.codeLifetimeMs);
  }
}
